import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function PasswordMinLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return value.length >= 8 ? null : { minlength: true };
  };
}

export function PasswordUppercaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /[A-Z]/.test(value) ? null : { uppercase: true };
  };
}

export function PasswordLowercaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /[a-z]/.test(value) ? null : { lowercase: true };
  };
}

export function PasswordDigitValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /\d/.test(value) ? null : { digit: true };
  };
}

export function PasswordSpecialCharValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /[@$!%*#?&]/.test(value) ? null : { special: true };
  };
}

export function ConfirmPasswordMatchValidator(
  passwordFieldName: string = 'password',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.parent?.get(passwordFieldName)?.value;
    return control.value && password && control.value !== password
      ? { mismatch: true }
      : null;
  };
}
